export const zh = {
  'app.name': '大易·决策罗盘',
  'app.tagline': '以古老智慧，照见当下抉择',
  'app.disclaimer': '内容仅供传统文化研究与生活参考，不构成任何决策、医疗或法律建议。',
  'nav.today': '今日',
  'nav.bazi': '八字',
  'nav.cast': '占问',
  'nav.profiles': '档案',
  'nav.settings': '设置',

  'common.confirm': '确认',
  'common.cancel': '取消',
  'common.save': '保存',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.add': '添加',
  'common.switch': '切换',
  'common.active': '当前',
  'common.name': '名称',
  'common.gender': '性别',
  'common.male': '男',
  'common.female': '女',
  'common.unknown': '不详',
  'common.loading': '加载中…',

  'header.login': '登录',
  'auth.skip': '暂不登录，先体验',
  'account.loginBtn': '登录 / 注册',
  'auth.login': '登入',
  'auth.register': '注册',
  'auth.email': '邮箱',
  'auth.password': '密码（至少 8 位）',
  'auth.nickname': '昵称（可选）',
  'auth.nicknamePlaceholder': '如何称呼你',
  'auth.loginBtn': '登入',
  'auth.registerBtn': '创建账号',
  'auth.dataNote': '登录后，档案与批注将保存在账号中，可在多设备同步；登出后本机不再保留你的数据。',
  'auth.error.invalidEmail': '请输入有效的邮箱地址',
  'auth.error.passwordWeak': '密码至少需要 8 位',
  'auth.error.emailExists': '该邮箱已注册，请直接登入',
  'auth.error.wrong': '邮箱或密码不正确',
  'auth.error.rateLimited': '操作过于频繁，请稍后再试',
  'auth.error.network': '无法连接服务器，请检查网络后重试',
  'auth.error.generic': '操作失败，请稍后重试',
  'account.title': '账号',
  'account.email': '邮箱',
  'account.nickname': '昵称',
  'account.logout': '登出',
  'account.logoutConfirm': '确定要登出吗？登出后本机的档案与批注缓存将被清除，云端数据不受影响。',
  'account.localData': '检测到本机还有 {n} 份旧档案未同步到账号，可一键导入（不会自动上传，保障账号隔离）。',
  'account.import': '导入到账号',
  'account.imported': '已导入 ✓',
  'account.importFailed': '导入失败，请稍后重试',

  'today.title': '今日宜忌',
  'today.subtitle': '结合你的八字与当日干支',
  'today.lunar': '农历',
  'today.solar': '公历',
  'today.ganzhi': '今日干支',
  'today.yi': '宜',
  'today.ji': '忌',
  'today.pengzu': '彭祖百忌',
  'today.jishen': '吉神',
  'today.xiongsha': '凶煞',
  'today.shen': '值神',
  'today.chong': '冲煞',
  'today.sha': '煞方',
  'today.positions': '吉神方位',
  'today.dayLuck': '今日对你',
  'today.dayLuck.good': '顺遂',
  'today.dayLuck.mid': '平顺',
  'today.dayLuck.bad': '宜守',
  'today.fiveElements': '五行能量',
  'today.advice': '给你的建议',
  'today.qiMen': '今日奇门',
  'today.switchProfile': '切换档案',
  'today.noProfile': '尚未添加八字档案，添加后即可获得个性化每日宜忌。',
  'today.addProfile': '添加档案',
  'today.energy.high': '精力与专注处于较好时段',
  'today.energy.low': '今日宜放缓节奏，蓄力待发',
  'today.energy.mid': '今日平稳，适合按部就班',
  'today.focusYear': '时运参考',
  'today.focusGanzhi': '流年',
  'today.focusDaYun': '所属大运',
  'today.focusLevel.good': '得助',
  'today.focusLevel.mid': '平稳',
  'today.focusLevel.bad': '有阻',
  'today.focusGenderHint': '性别不详，大运顺逆仅供参考。',

  'bazi.title': '四柱八字',
  'bazi.subtitle': '基于真太阳时排盘',
  'bazi.pillars': '四柱',
  'bazi.year': '年柱',
  'bazi.month': '月柱',
  'bazi.day': '日柱',
  'bazi.hour': '时柱',
  'bazi.dayMaster': '日主',
  'bazi.hiddenStems': '藏干',
  'bazi.tenGods': '十神',
  'bazi.nayin': '纳音',
  'bazi.stems': '天干',
  'bazi.branches': '地支',
  'bazi.wuxing': '五行分布',
  'bazi.strength': '日主强弱',
  'bazi.usefulGod': '喜用神',
  'bazi.avoidGod': '忌神',
  'bazi.daYun': '大运',
  'bazi.liuNian': '流年',
  'bazi.birthInfo': '出生信息',
  'bazi.solarTime': '真太阳时',
  'bazi.standardTime': '北京时间',
  'bazi.taiYuan': '胎元',
  'bazi.mingGong': '命宫',
  'bazi.xunKong': '旬空',
  'bazi.verdict': '总评',
  'bazi.strength.strong': '强',
  'bazi.strength.weak': '弱',
  'bazi.strength.mid': '中',
  'qimen.xunShou': '旬首',
  'qimen.zhiFu': '值符',
  'qimen.zhiShi': '值使',
  'qimen.level.good': '吉 · 宜动',
  'qimen.level.mid': '平 · 待时',
  'qimen.level.bad': '凶 · 宜守',
  'bazi.daYun.startAge': '起运',
  'bazi.god.wealth': '正财',
  'bazi.god.officer': '正官',
  'bazi.god.seal': '正印',
  'bazi.god.rob': '比肩',
  'bazi.god.eat': '食神',
  'bazi.god.kill': '七杀',
  'bazi.god.hurt': '伤官',
  'bazi.god.wealth2': '偏财',
  'bazi.god.officer2': '偏官',
  'bazi.god.seal2': '偏印',

  'cast.title': '占问当下',
  'cast.subtitle': '梅花易数 · 一事一占',
  'cast.method': '起卦方式',
  'cast.method.numbers': '心中报数',
  'cast.method.time': '当前时间',
  'cast.method.words': '汉字起卦',
  'cast.askPlaceholder': '你正在为什么而纠结？（可选，帮助解读更贴合）',
  'cast.numberHint': '心中默念所问之事，报出三个数字（或看表取三个数字）',
  'cast.wordsHint': '写下所想之事相关的几个字（2-6字）',
  'cast.btn': '起卦',
  'cast.result.title': '卦象解读',
  'cast.primary': '主卦',
  'cast.mutual': '互卦',
  'cast.changed': '变卦',
  'cast.body': '体卦',
  'cast.use': '用卦',
  'cast.bodyUse': '体用关系',
  'cast.qi': '卦气',
  'cast.month': '起卦月令',
  'cast.verdict': '总体判断',
  'cast.yings': '应期提示',
  'cast.yaoText': '动爻',
  'cast.retry': '再占一卦',
  'cast.adviceTitle': '给你的叙事式建议',
  'cast.adviceShort': '给你的建议',

  'cast.bodyUse.sheng': '用生体：得助',
  'cast.bodyUse.ke': '用克体：受制',
  'cast.bodyUse.bihe': '体用比和：顺遂',
  'cast.bodyUse.shengBody': '体生用：付出',
  'cast.bodyUse.keBody': '体克用：掌控',
  'cast.qi.monthShengBody': '月令生体，得天时之助',
  'cast.qi.monthKeBody': '月令克体，宜静不宜动',
  'cast.qi.bihe': '月令与体卦比和',
  'cast.qi.bodyShengMonth': '体卦生月令，宜蓄力',
  'cast.qi.bodyKeMonth': '体克月令，主动可为',

  'qimen.title': '奇门遁甲',
  'qimen.subtitle': '时家奇门 · 择时与方位',
  'qimen.ju': '局数',
  'qimen.yuan': '三元',
  'qimen.dun': '遁',
  'qimen.plate': '九宫盘',
  'qimen.palace': '宫',
  'qimen.stars': '九星',
  'qimen.doors': '八门',
  'qimen.gods': '八神',
  'qimen.skyPan': '天盘',
  'qimen.earthPan': '地盘',
  'qimen.gan': '奇仪',
  'qimen.goodDoor': '吉门',
  'qimen.goodStar': '吉星',
  'qimen.wonder': '三奇',
  'qimen.verdict': '择时建议',
  'qimen.person': '日干落宫',
  'qimen.time': '时干落宫',
  'qimen.mode.switch': '切换为奇门遁甲',
  'qimen.mode.meihua': '切换为梅花易数',
  'qimen.now': '以当前时刻起局',
  'today.qimenReading': '今日奇门解说',
  'cast.qimenReading': '奇门遁甲解说',

  'profile.title': '八字档案',
  'profile.subtitle': '保存多个出生信息，随时切换',
  'profile.nickname': '昵称（如：我自己 / 家人）',
  'profile.birthDate': '出生日期',
  'profile.birthTime': '出生时辰',
  'profile.birthDateHint': '请滑动选择出生年月日；选好后会直接显示在框内。',
  'profile.birthCity': '出生城市（用于真太阳时校正）',
  'profile.cityPlaceholder': '如：北京 / 上海（可留空）',
  'profile.unknownTime': '时辰不详',
  'profile.add': '新建档案',
  'profile.edit': '编辑档案',
  'profile.deleteConfirm': '确定删除该档案吗？',
  'profile.empty': '还没有档案，点击下方按钮添加你的出生信息。',
  'profile.required': '请填写昵称与出生日期',
  'profile.focusYear': '时运（选填）',
  'profile.focusYearNone': '不设置（跟随当下）',
  'profile.focusYearHint': '选择关注的年份后，每日宜忌将结合该年流年与大运进一步个性化。',

  'settings.ai': '命书服务',
  'settings.ai.builtin': '内置 DeepSeek 服务',
  'settings.ai.builtinDesc': '由站点提供方内置配置（服务端代理），无需填写密钥即可直接使用。',
  'settings.ai.custom': '自定义服务',
  'settings.ai.customDesc': '正在使用自定义兼容服务（密钥仅存本机）。',
  'settings.ai.advanced': '高级：自定义服务',
  'settings.ai.hideAdvanced': '收起高级设置',
  'settings.ai.advancedHint': '如需使用自己的服务商或代理，可在此配置。清空密钥即恢复内置服务。',
  'settings.ai.baseUrl': '接口地址',
  'settings.ai.model': '模型名称',
  'settings.ai.apiKey': 'API 密钥（留空 = 内置服务）',
  'settings.ai.apiKeyPlaceholder': '留空则使用内置服务',
  'settings.ai.useBuiltin': '恢复内置服务',
  'settings.ai.save': '保存配置',
  'settings.ai.test': '测试连接',
  'settings.ai.testing': '测试中…',
  'settings.ai.testOk': '连接成功 ✓',
  'settings.ai.testFail': '连接失败',
  'settings.ai.saved': '配置已保存',
  'settings.ai.privacy': '内置服务：请求经站点代理转发，密钥由站点持有；自定义模式：密钥仅保存在本机浏览器，请求直接发送到你配置的接口地址。',

  'bazi.reading': '命书批注',
  'bazi.reading.subtitle': '一次性生成 · 永久存档 · 删除后可重新生成',
  'bazi.reading.empty': '这份档案还没有详细批注。生成后会自动存档，之后每次打开都会直接显示，不会重复生成。',
  'bazi.reading.generate': '生成详细批注',
  'bazi.reading.generating': '正在生成批注…（约需 30–60 秒，请勿关闭页面）',
  'bazi.reading.noKey': '尚未配置命书服务，请先到「设置」页填写 API 密钥。',
  'bazi.reading.error': '生成失败',
  'bazi.reading.createdAt': '生成时间',
  'bazi.reading.delete': '删除批注',
  'bazi.reading.deleteConfirm': '删除后可以重新生成。确定删除这份批注档案吗？',
  'bazi.reading.advice': '行动建议',
  'bazi.reading.sectionTitle': '批注正文',
  'settings.title': '设置',
  'settings.language': '语言 / Language',
  'settings.theme': '主题',
  'settings.theme.system': '跟随系统',
  'settings.theme.light': '浅色',
  'settings.theme.dark': '深色',
  'settings.about': '关于',
  'settings.version': '版本',
  'settings.dataLocal': '所有数据仅保存在本机浏览器中。',
  'settings.ethics': '易学是观察与自省的古老智慧，请理性看待，切勿盲从。',

  'wuxing.metal': '金',
  'wuxing.wood': '木',
  'wuxing.water': '水',
  'wuxing.fire': '火',
  'wuxing.earth': '土',
  'direction.north': '北',
  'direction.south': '南',
  'direction.east': '东',
  'direction.west': '西',
  'direction.ne': '东北',
  'direction.nw': '西北',
  'direction.se': '东南',
  'direction.sw': '西南',
  'direction.center': '中',
} as const;

